module.exports = __webpack_public_path__ + "static/media/arrow_drop_up.4d9a4229.svg";